import React from 'react'
import HeaderEight from "../components/header/HeaderEight";
import BannerEight from "../components/banner/BannerEight";
import CtaEight from "../components/calltoaction/CtaEight";
import ServiceSeven from "../components/service/ServiceSeven";
import ServiceEight from "../components/service/ServiceEight";
import WorkingProcessFive from "../components/workingprocess/WorkingProcessFive";
import ContactFormFour from "../components/contactform/ContactFormFour";
import WhyChooseUs from "../components/whychooseus/WhyChooseUs";



import FooterSeven from "../components/footer/FooterSeven";

function HomeOne() {
    return (
        <div className='home-blue medium-blue'>

            <HeaderEight />
            <BannerEight />
            <WhyChooseUs />
            <CtaEight />
            <ServiceSeven />
            <ServiceEight />
           
            <WorkingProcessFive />
            {/* <CseSeven /> */}
            {/* <TestimonialEight /> */}
            {/* <PricingOne /> */}
            <ContactFormFour />



            {/* <BlogEight /> */}



            <FooterSeven />

        </div>
    )
}

export default HomeOne